module.exports = {
  //  baseUrl: "http://192.168.31.252:8808", // 测试刁
  //  baseUrl: "http://192.168.0.105:8808", // 测试刁 澳亚驻场IP
  // baseUrl: "http://192.168.31.232:8808", // 测试钟
  // baseUrl: "http://192.168.110.166:8808", // 测试石
  // baseUrl: "http://192.168.31.240:8888"
  baseUrl: 'http://ztfz.dtsum.com', // 正式上线
  // baseUrl: 'http://zongtongtest.dtsum.com', // 测试上线
  // baseUrl: 'http://192.168.110.200:8818', 
};
